<template>
  <base-modal
    :reference="'deleteStop_' + stop.id"
    :title="'Confirmación de eliminación de parada vinculada'"
    :acceptAction="acceptAction"
    :cancelActionText="'Cerrar'"
    :size="'lg'"
  >
    <template v-slot:body v-if="show">
        <div>
            <p class="alert-info rounded-sm w-75 mx-auto py-2 px-2">
                Por favor, confirme que quiere eliminar del listado la parada <strong>{{stop.geo_point.name}}</strong> del grupo <strong>{{activity_group.name}}</strong>. <span style="text-decoration: underline;">El punto geográfico vinculado no se eliminará.</span>
            </p>
        </div> 
        <div>
            <b-button
                class="border mr-2 btn-danger font-weight-bold" style="color: white;"
                size="sm"
                variant=""
                @click="deleteStop"
            >
                <i class="text-center fa fa-trash fa-fw"></i>
                Eliminar
            </b-button>

        </div>
    </template>
    <template v-slot:accept-action>
        <span></span>
    </template>

  </base-modal>
</template>

<script>

import BaseModal from "../../Excursions/Booking/Modal/BaseModal";

export default {
  components: {
    BaseModal,
  },
  props: {
    stop: {
        type: Object || undefined ,
        required: false,
    },
    activity_group: {
        type: Object,
        required: false,
    }
  },
  data() {
    return {
        show: false,
    }
  },
  async mounted() {
    this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
      const current = "deleteStop_" + this.stop.id;
      if (modalId == current) {
            this.show = true
      }
    });
  },
  beforeDestroy() {
  },
  methods: {
        async deleteStop() {
            let data = {
                stop_id: this.stop.id,
            }
            this.$store.dispatch('stops/deleteStopSchedule', data)
            .then( async () => {
                const data = {
                  'activity_group_id': this.activity_group.id,
                }
                await this.$store.dispatch("stops/loadStopsAdmin", data)
                this.$notify({
                    group: "foo",
                    title: "La parada se ha eliminado",
                    text: "La parada " + this.stop.geo_point.name + " del grupo " + this.activity_group.name + " se ha eliminado satisfactoriamente",
                    type: "success",
                });
            })
            .catch( (error) => {
                this.$notify({
                    group: "foo",
                    title: "La parada no se puede eliminar",
                    text: error.response.data.detail,
                    type: "error",
                });
            })
        },
        acceptAction() {
          this.$bvModal.hide('deleteStop_' + this.stop.id)
        }
  },
  
};
</script>